/**
 * API functions for CRM integration
 */
import { createCloudRunAxios } from './axios';

const remiApi = createCloudRunAxios('remi-api');

interface CRMApiResponse {
  api_response: {
    message: string;
    status: string;
  };
  message: string;
  org_id: string;
  success: boolean;
}

/**
 * Add a client to CRM
 * @param organizationId The organization ID
 * @param email The client email
 * @param password The client password
 * @returns A promise that resolves to true if successful
 */
export const addCRMClient = async (
  organizationId: string,
  email: string,
  password: string
): Promise<boolean> => {
  if (!organizationId || !email || !password) {
    throw new Error('Organization ID, email, and password are required');
  }

  try {
    const response = await remiApi.post<CRMApiResponse>(
      '/api/v1/integrations/add-external-client',
      {
        org_id: organizationId,
        email: email,
        password: password,
      }
    );

    const data = response.data;

    if (!data.success) {
      throw new Error('Failed to add CRM integration');
    }

    console.log('CRM client added successfully:', data.message);
    return true;
  } catch (error) {
    console.error('Error adding CRM client:', error);
    throw error;
  }
};
